import React, {useEffect, useState} from 'react';
import {object, string} from "yup";
import PropTypes from "prop-types";
import {Col, Container, Form, Row} from "react-bootstrap";
import {useForm} from "react-hook-form";
import SvgIcon from "@material-ui/core/SvgIcon";
import Button from "@material-ui/core/Button";
import PageIcon from "../../../../icons/NotesPagesNotification.svg";
import {httpRequest} from "../../../../httpRequest";
import {SelectInput, TextInput} from "../../../Helpers/Inputs";
import {NumberFormatDollars} from "../../../Helpers/Formatters";
import {setBenefitDurationOptions, setPremiumModeOptions, defaultBenefitDurationList, defaultPremiumModeList, eliminationPeriodOptions, benefitPeriodOptions} from "./Helpers/Lists";
import { CircularProgress } from '@material-ui/core';
import { customValidators, number as yupnumber } from "../../../Helpers/Validators/customValidators";
import { emptyStringToUndefined, currencyStringToNumber } from '../../../Helpers/Formatters/EmptyStringToUndefined';

export default function SelectProduct(props) {
  const { formState, fullFormState, onNext, onBack, onFieldChange, residentState, insuredAge } = props;

  const {register, errors, handleSubmit, setValue, triggerValidation} = useForm({
    validationSchema: SelectProduct.ValidationSchema(props.isDICreateCase),
    mode: 'onBlur',
    reValidateMode: 'onBlur',
  });

  useEffect(() => {
    register({ name: 'category' });
    setValue('category', formState.category);

    register({ name: 'firstYearPremium' });
    setValue('firstYearPremium', formState.firstYearPremium);

    register({ name: 'recurringAnnualPremium' });
    setValue('recurringAnnualPremium', formState.recurringAnnualPremium);

    register({ name: 'carrier' });
    setValue('carrier', formState.carrier);

    register({ name: 'product' });
    setValue('product', formState.product);

    register({ name: 'coverage' });
    setValue('coverage', formState.coverage);

    register({name: 'specificCoverage'});
    setValue('specificCoverage', formState.specificCoverage);

    register({ name: 'premium' });
    setValue('premium', formState.premium);
  }, [register]);

  const [carrierList, setCarrierList] = useState([]);
  const [carrierListEnabled, setCarrierListEnabled] = useState(false);
  const [carrierListLoading, setCarrierListLoading] = useState(false);
  const [productList, setProductList] = useState([]);
  const [productListEnabled, setProductListEnabled] = useState(false);
  const [productListLoading, setProductListLoading] = useState(false);
  const [coverageList, setCoverageList] = useState([]);
  const [benefitDurationList, setBenefitDurationList] = useState(defaultBenefitDurationList());
  const [premiumModeList, setPremiumModeList] = useState(defaultPremiumModeList());
  const [approvedProducts, setApprovedProducts] = useState([]);
  const [loading,setLoading]= useState(false);

  useEffect(() => {
    if (approvedProducts.length > 0 && formState.category !== '') {
      getCarriersByCategory();
      if(formState.carrier)
        getProductsByCarrier();
    }
  }, [approvedProducts])

  useEffect(() => {
    if (approvedProducts.length === 0) {
      const getProducts = async () => {
        setLoading(true);
        const msApprovedProducts = await getMSApprovedProducts();
        setApprovedProducts(msApprovedProducts.content);
        setLoading(false);
      }
      getProducts();
    }
    getCoverageByCategory();
  }, [formState.category])

  const getMSApprovedProducts = async () => {
    try {
      const covrServicesBaseUrl = process.env.REACT_APP_COVR_SERVICES_URL;
      const productCategoryForDI = formState.category === 'DI' ? 'DI' : 'UL,VUL,WL';
      const productCategory = formState.isSelectedProduct && formState.category === 'LTC' ? formState.category : productCategoryForDI;
      const productType = ((formState.category === 'LTC' && props.isMSEnableABLTCCreateCaseSurvivorshipWorkflow) || (formState.category === 'PERM' && props.isMSEnablePERMCreateCaseSurvivorshipWorkflow)) ? (props.isSurvivorshipPolicy ? "S" : "I") : "";
      return await httpRequest.get(`${covrServicesBaseUrl}/api/MorganStanley/GetApprovedProducts?state=${residentState}&productCategory=${productCategory}&productType=${productType}`);
    } catch (err) {
      console.log(err);
    }
  }

  const getCarriersByCategory = () => {
    try {
      setCarrierListLoading(true);
      setCarrierListEnabled(false);

      const categories = approvedProducts.map(({ carrierCode, carrierName }) => ({ carrierCode, carrierName }));
      const uniqueCarriers = Array.from(new Set(categories.map(x => x.carrierCode)))
        .map(carrierCode => {
          return {
            carrierCode: carrierCode,
            carrierName: categories.find(x => x.carrierCode === carrierCode).carrierName
          };
        });

      const carrierOptions = uniqueCarriers.map((c) => {
        return { label: c.carrierName, value: c.carrierCode }
      });

      setCarrierList(carrierOptions);
      setCarrierListLoading(false);
      setCarrierListEnabled(true);

    } catch (err) {
      console.log(err);
    }
  }

  const getProductsByCarrier = () => {
    try {
      setProductListLoading(true);
      setProductListEnabled(false);

      const productOptions = approvedProducts.filter(c => c.carrierCode === formState.carrier).map((p) => {
        return { label: p.productName, value: p.productName, code: p.productCode, category: p.productCategory }
      });

      setProductList(productOptions);
      setProductListLoading(false);
      setProductListEnabled(true);
    } catch (err) {
      console.log(err);
    }
  }

  const convertAmount = (value,numDecimals) => {
    var n = value,
      numDecimals = (numDecimals == null) ? 2 : numDecimals,
      d = ".",
      t = ",",
      s = n < 0 ? "-" : "",
      i = parseInt(n = Math.abs(+n || 0).toFixed(numDecimals)) + "",
      j = (j = i.length) > 3 ? j % 3 : 0;
    return s + (j ? i.substr(0, j) + t : "") + i.substr(j).replace(/(\d{3})(?=\d)/g, "$1" + t) + (numDecimals ? d + Math.abs(n - i).toFixed(numDecimals).slice(2) : "");

  }

  const getCoverageByCategory = () => {
    let AmountOptions = [];
    if(formState.category.toUpperCase() === 'LTC'){
      AmountOptions.push({ label: `Enter Specific Amount`, value: 'specificPremium' })
      for(var i = 50000;i <= 500000; i += 50000){
        AmountOptions.push({ label: `$${convertAmount(i)}`, value: `${i}` })
      }
    }
    setCoverageList(AmountOptions);
  }

  const handleValueChange = async (field, value) => {
    let newForm = { ...props.fullFormState }

    if (field === 'carrier') {
      if (value === null) {
        setValue('product', '');
        newForm.pages.selectProduct.product = '';
      }
      const carrierName = carrierList && carrierList.find((carrier) => carrier.value === value)
      setValue('product', '');
      newForm.pages.selectProduct.product = '';
      setValue('carrier', value);
      newForm.pages.selectProduct.carrier = value;
      newForm.pages.selectProduct.carrierName = carrierName.label
      props.onMultiFieldChange(newForm);
      getProductsByCarrier();
      triggerValidation(field);
      return;
    }

    if (field === 'benefitPeriod' && value !== 'other') {
      setValue('benefitPeriodOther', '');
      newForm.pages.selectProduct.benefitPeriodOther = '';
      setValue('benefitPeriod', value);
      newForm.pages.selectProduct.benefitPeriod = value;
      props.onMultiFieldChange(newForm);
      triggerValidation(field);
    }

    if (field === 'product' && value !== null) {
      onFieldChange('benefitDuration', '');
      onFieldChange('premiumMode', '');
      setValue('benefitDuration', '');
      setValue('premiumMode', '');
      const ProductName = productList && productList.find((product) => product.value === value)
      newForm.pages.selectProduct.productCode = ProductName.code
      newForm.pages.selectProduct.product = value;
      newForm.pages.selectProduct.productCategory = ProductName.category;

      // set bmsPlanID and bmsCarrierID from selected product
      const selectedProductDetails = approvedProducts && approvedProducts.find(item => item.productCode === ProductName.code);
      newForm.pages.selectProduct.bmsPlanID = selectedProductDetails ? selectedProductDetails.bmsPlanID : null;
      newForm.pages.selectProduct.bmsCarrierID = selectedProductDetails ? selectedProductDetails.bmsCarrierID : null;

      let isOwner = !!(fullFormState.pages.retrieveAccount &&
        fullFormState.pages.retrieveAccount.isProposedInsured === 'true');

      let benefitList = defaultBenefitDurationList();
      let premList = defaultPremiumModeList();

      setBenefitDurationOptions(value, benefitList, setBenefitDurationList);
      setPremiumModeOptions(value, premList, setPremiumModeList, isOwner, insuredAge, residentState)
      props.onMultiFieldChange(newForm);
      triggerValidation(field);
    }

    await setValue(field, value);
    await onFieldChange(field, value);
    await triggerValidation(field);
  };

  const handleCoverageValueChange = (field, value) => {
    if ((field === "coverage" || field === "firstYearPremium" || field === "recurringAnnualPremium") && props.formState.category !== "LTC"  && props.formState.coverage !== '' && props.formState.firstYearPremium !== "" && props.formState.recurringAnnualPremium !=="") {
      triggerValidation(['firstYearPremium', 'recurringAnnualPremium']);
    }
    if ((field === 'coverage' || field === 'premium' || field === 'specificPremium' || field === 'premiumMode') && props.formState.coverage !== '' && props.formState.premium !== '' && props.formState.premiumMode !== '' && props.formState.specificPremium !== '' && props.formState.category.toUpperCase() === "LTC") {
      triggerValidation('coverage');
    }
    setValue(field, value);
    onFieldChange(field, value);
    triggerValidation(field);
  }

  return (
    <Container fluid className="border-class">
      <form className="InsuredBasicInfoForm" onSubmit={handleSubmit(onNext)}>
        <Row className="justify-content-center pt-4">
          <Col lg={4}>
            <div className="text-center">
              <SvgIcon fontSize="large" color="primary" className="icons" component={PageIcon} />
            </div>
            <h4 className="text-center owner-info mt-3 mb-4">
              <b>Product Information</b>
            </h4>
            {loading ?
              <Row className="d-flex justify-content-center">
                <CircularProgress className="mt-5 mb-5" />
              </Row>
              :
              <div>
                <Form.Group>
                  <SelectInput
                    name="carrier"
                    id="carrier"
                    value={formState.carrier}
                    onChange={(e) => handleValueChange('carrier', e.target.value)}
                    label="Carrier"
                    selectOptions={carrierList}
                    errors={errors.carrier}
                    inputRef={register}
                    disabled={!carrierListEnabled}
                    loadingList={carrierListLoading}
                  />
                </Form.Group>

                <Form.Group>
                  <SelectInput
                    name="product"
                    id="product"
                    value={formState.product}
                    onChange={(e) => handleValueChange('product', e.target.value)}
                    label="Product"
                    selectOptions={productList}
                    errors={errors.product}
                    inputRef={register}
                    disabled={!productListEnabled}
                    loadingList={productListLoading}
                  />
                </Form.Group>

                {
                  formState.category.toUpperCase() === 'LTC' &&
                  <React.Fragment>
                    <Form.Group>
                      <SelectInput
                        name="benefitDuration"
                        id="benefitDuration"
                        value={formState.benefitDuration}
                        onChange={(e) => handleValueChange('benefitDuration', e.target.value)}
                        label="Benefit Duration"
                        selectOptions={benefitDurationList}
                        errors={errors.benefitDuration}
                        inputRef={register}
                      />
                    </Form.Group>

                    <Form.Group>
                      <SelectInput
                        name="premiumMode"
                        id="premiumMode"
                        value={formState.premiumMode}
                        onChange={(e) => handleCoverageValueChange('premiumMode', e.target.value)}
                        label="Premium Mode"
                        selectOptions={premiumModeList}
                        errors={errors.premiumMode}
                        inputRef={register}
                      />
                    </Form.Group>
                    <Form.Group>
                      <SelectInput
                        name="premium"
                        id="premium"
                        label="Premium Amount"
                        value={formState.premium}
                        selectOptions={coverageList}
                        errors={errors && errors.premium}
                        inputRef={register}
                        onChange={(e) => handleCoverageValueChange('premium', e.target.value)}
                        InputProps={{
                          inputComponent: NumberFormatDollars,
                        }}
                      />
                    </Form.Group>
                    {formState.premium === 'specificPremium' &&
                      <Form.Group>
                        <TextInput
                          name="specificPremium"
                          id="specificPremium"
                          label={formState.category === 'LTC' ? "Total Premium Amount" : "Specific Premium Amount"}
                          value={formState.specificPremium}
                          errors={errors && errors.specificPremium}
                          inputRef={register}
                          onChange={(e) => handleCoverageValueChange('specificPremium', e.target.value)}
                          InputProps={{
                            inputComponent: NumberFormatDollars,
                          }}
                        />
                      </Form.Group>}
                  </React.Fragment>
                }

                <Form.Group>
                  <TextInput
                    name="coverage"
                    id="coverage"
                    label={props.isDICreateCase ? "Coverage (Monthly Disability Benefit)" : "Coverage (Death Benefit)"}
                    value={formState.coverage}
                    errors={errors && errors.coverage}
                    inputRef={register}
                    onChange={(e) => handleCoverageValueChange('coverage', e.target.value)}
                    InputProps={{
                      inputComponent: NumberFormatDollars,
                    }}
                  />
                </Form.Group>

                {
                  (formState.coverage === 'specificCoverage') &&
                  <Form.Group>
                    <TextInput
                      name="specificCoverage"
                      id="specificCoverage"
                      label="Specific Coverage Amount"
                      value={formState.specificCoverage}
                      errors={errors && errors.specificCoverage}
                      inputRef={register}
                      onChange={(e) => handleValueChange('specificCoverage', e.target.value)}
                      InputProps={{
                        inputComponent: NumberFormatDollars,
                      }}
                    />
                  </Form.Group>
                }

                {formState.category === 'DI' &&
                  (<React.Fragment>
                    <Form.Group>
                      <SelectInput
                        name="eliminationPeriod"
                        id="eliminationPeriod"
                        label="Elimination Period"
                        value={formState.eliminationPeriod}
                        selectOptions={eliminationPeriodOptions}
                        errors={errors && errors.eliminationPeriod}
                        inputRef={register}
                        onChange={(e) => handleCoverageValueChange('eliminationPeriod', e.target.value)}
                      />
                    </Form.Group>
                    <Form.Group>
                      <SelectInput
                        name="benefitPeriod"
                        id="benefitPeriod"
                        label="Benefit Period"
                        value={formState.benefitPeriod}
                        selectOptions={benefitPeriodOptions}
                        errors={errors && errors.benefitPeriod}
                        inputRef={register}
                        onChange={(e) => handleValueChange('benefitPeriod', e.target.value)}
                      />
                    </Form.Group>
                    {formState.benefitPeriod === 'Other' && (<Form.Group>
                      <TextInput
                        name="benefitPeriodOther"
                        id="benefitPeriodOther"
                        label="Other"
                        value={formState.benefitPeriodOther}
                        errors={errors && errors.benefitPeriodOther}
                        inputRef={register}
                        onChange={(e) => handleCoverageValueChange('benefitPeriodOther', e.target.value)}
                      />
                    </Form.Group>)}
                  </React.Fragment>)
                }

                {(formState.category === 'PERM' || formState.category === 'DI') &&
                  (<React.Fragment>
                    <Form.Group>
                      <TextInput
                        name="firstYearPremium"
                        id="firstYearPremium"
                        label="First Year Premium"
                        value={formState.firstYearPremium}
                        errors={errors && errors.firstYearPremium}
                        inputRef={register}
                        onChange={(e) => handleCoverageValueChange('firstYearPremium', e.target.value)}
                        InputProps={{
                          inputComponent: NumberFormatDollars,
                        }}
                      />
                    </Form.Group>
                    {formState.category !== 'DI' &&
                      <Form.Group>
                        <TextInput
                          name="recurringAnnualPremium"
                          id="recurringAnnualPremium"
                          label="Recurring Annual Premium"
                          value={formState.recurringAnnualPremium}
                          errors={errors && errors.recurringAnnualPremium}
                          inputRef={register}
                          onChange={(e) => handleCoverageValueChange('recurringAnnualPremium', e.target.value)}
                          InputProps={{
                            inputComponent: NumberFormatDollars,
                          }}
                        />
                      </Form.Group>}
                  </React.Fragment>)
                }
              </div>
            }
          </Col>
        </Row>
        <Row className="pt-5 mb-4 mx-2">
          <Col className="text-left btn-back">
            <Button variant="outlined" size="medium" color="primary" onClick={onBack}>
              BACK
            </Button>
          </Col>
          <Col className="text-right">
            <Button variant="contained" size="medium" color="primary" type="submit" disabled={loading || props.roleType == 'operations' || props.roleType == 'non-producing branch manager'}>
              NEXT
            </Button>
          </Col>
        </Row>
      </form>
    </Container>
  )
}

SelectProduct.propTypes = {
  formState: PropTypes.object.isRequired,
  onNext: PropTypes.func.isRequired,
  onFieldChange: PropTypes.func.isRequired,
  onBack: PropTypes.func.isRequired,
};

SelectProduct.DefaultFormState = (prefill, selectedProduct) => {
  return {
    category: (selectedProduct && selectedProduct.submitCaseProductKey) || '',
    firstYearPremium: '',
    recurringAnnualPremium: '',
    carrier: '',
    product: '',
    coverage: '',
    benefitDuration: '',
    premiumMode: '',
    isSelectedProduct: (selectedProduct && selectedProduct.submitCaseProductKey) ? true : false,
    carrierName: '',
    productCode: '',
    productCategory: '',
    bmsPlanID: '',
    bmsCarrierID: '',
    eliminationPeriod: '',
    benefitPeriod: '',
    benefitPeriodOther: ''
  };
};

SelectProduct.ValidationSchema = (isDICreateCase) => {
  const fieldNameForCoverage = isDICreateCase ? 'Coverage (Monthly Disability Benefit)' : 'Coverage (Death Benefit)';
  const minCoverageValue = isDICreateCase ? 100 : 10000;
  return object().shape({
    category: string().required("Category is required."),
    firstYearPremium: string().when('category', {
      is: (category) => (category.toUpperCase() === 'PERM' || isDICreateCase),
      then: customValidators.string().isValidAmountRange('First Year Premium is required.', 1, 10000000, 'The field First Year Premium must be between 1 and 10000000.'),
      otherwise: string().nullable().transform(emptyStringToUndefined).notRequired()
    }),
    recurringAnnualPremium: string().when('category', {
      is: (category) => (category.toUpperCase() === 'PERM' && !isDICreateCase),
      then: customValidators.string().isValidAmountRange('Recurring Annual Premium is required.', 1, 10000000, 'The field Recurring Annual Premium must be between 1 and 10000000.'),
      otherwise: string().nullable().transform(emptyStringToUndefined).notRequired()
    }),
    carrier: string().required("Carrier is required."),
    product: string().required("Product is required."),
    benefitDuration: string().when('category', {
      is: (category) => category.toUpperCase() === 'LTC',
      then: string().required('Benefit Duration is required.'),
      otherwise: string().notRequired()
    }),
    premiumMode: string().when('category', {
      is: (category) => category.toUpperCase() === 'LTC',
      then: string().required('Premium Mode is required.'),
      otherwise: string().notRequired()
    }),
    premium: string().when('category', {
      is: (category) => category.toUpperCase() === 'LTC',
      then: string().required('Premium Amount is required.'),
      otherwise: string().notRequired()
    }),
    specificPremium: string().when(['category', 'premium'], {
      is: (category, premium) => (category.toUpperCase() === 'LTC' && premium === 'specificPremium'),
      then: customValidators.string().isValidAmountRange('Specific Premium is required.', 0, 1000000, 'The field Specific Premium Amount must be between 0 and 1000000.'),
      otherwise: string().notRequired()
    }),
    coverage: string().when('category', {
      is: (category) => category.toUpperCase() !== 'LTC',
      then: customValidators.string().isValidAmountRange('Coverage is required.', minCoverageValue, 25000000, `The field ${fieldNameForCoverage} must be between ${minCoverageValue} and 25000000.`),
      otherwise: string().when(['premium', 'specificPremium', 'premiumMode'], (premium, specificPremium, premiumMode) => {
        return customValidators.string().isValidCoverageAmount(premium, specificPremium, premiumMode);
      }),
    }),
    specificCoverage: string().when('coverage', {
      is: (coverage) => coverage === 'specificCoverage',
      then: string().required('Specific Coverage is required.'),
      otherwise: string().notRequired()
    }),
    benefitPeriod: string().when('category', {
      is: (category) => category.toUpperCase() === 'DI',
      then: string().required('Benefit Period is required.'),
      otherwise: string().notRequired()
    }),
    eliminationPeriod: string().when('category', {
      is: (category) => category.toUpperCase() === 'DI',
      then: string().required('Elimination Period is required.'),
      otherwise: string().notRequired()
    }),
    benefitPeriodOther: string().when(['category', 'benefitPeriod'], {
      is: (category, benefitPeriod) => category.toUpperCase() === 'DI' && benefitPeriod.toUpperCase() === 'OTHER',
      then: customValidators.string()
        .isValidNameLimitedSpecialChar("The field Other is required.", true, false),
      otherwise: string().notRequired()
    }),
  });
};


// WEBPACK FOOTER //
// ./src/components/Product/SharedComponents/SelectProduct/SelectProduct.js